import { z } from "zod";

/**
 * The active customer profile selection persisted per external user by the
 * `user-preferences/active-customer` API. `customerProfileId` corresponds to a
 * `CustomerDetails.id`. The API returns `0` when the user has no accessible
 * customer profiles.
 */
export const activeCustomerProfileSchema = z.object({
	customerProfileId: z.number(),
});
export type ActiveCustomerProfile = z.infer<typeof activeCustomerProfileSchema>;
